import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MemoryCacheService {
  static WellKnownKeys = {
    accountId: 'accountId',
    postingIds: 'postingIds',
    brandIds: 'brandIds',
    jobTitles: 'jobTitles',
    locationIds: 'locationIds',
  };

  cache = {};

  add(key: string, value): void {
    this.cache[key] = value;
  }

  get<T>(key: string): T {
    return this.cache[key] as T;
  }

  remove(key: string): void {
    delete this.cache[key];
  }
}
